import { Suspense } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { useDevice } from "./providers/DeviceProvider";
import { Routes, Route } from "react-router";
import NotFoundPage from "./components/pages/error/NotFoundPage";
import { Intercom } from "@intercom/messenger-js-sdk";
import config from "./config";
import useStaggeredValue from "./hooks/useStaggeredValue";
import FormRoot from "./components/pages/formbase/FormRoot";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%",
      height: "100%",
      position: "absolute",
      background: theme.palette.background.default
    },
    contentMobile: {
      width: "100%",
      height: "100%",
    },
    contentDesktop: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
  })
);

export default function App() {
  const { classes } = useStyles();
  const { isMobilePortraitView, slim, sidebarOpen, setSidebarOpen, isMobile, compactMode, setCompactMode } = useDevice();

  const compactLayoutReady = useStaggeredValue(compactMode, 255);


  /*
  useEffect(() => {
    if (!user) return;
    Intercom({
      app_id: config.intercomId,
      user_id: user.sub,
      name: user.name,
      email: user.email,
      hide_default_launcher: slim,
      custom_attributes: {
        assist_version: config.version
      }
    });
  }, [user, slim]);
*/

  return (
    <div className={classes.root}>
      <Box className={slim ? classes.contentMobile : classes.contentDesktop}>
        <Suspense>
          <Routes>
            
            <Route path="/form/:linkId" element={<FormRoot />} />

            <Route path="*" element={<NotFoundPage />} />

          </Routes>
        </Suspense>
      </Box>
    </div>
  );
}